export const NAME = 'name';
export const OWNER = 'owner';
export const PARTNER_COMPANY = 'partnerCompany';
export const AFFILIATES = 'affiliates';
export const NETWORKS = 'networks';
export const INTEGRATED_PARTNER = 'partnerApi';
export const INTEGRATION_START_DATE = 'startDate';

export const COST_MODELS_END_DATE = 'costModelsEndDate';
